import { Box, Button, Typography } from "@mui/material";
import { useLogout } from "@refinedev/core";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export const Unauthorized = () => {
  const { mutate: logout } = useLogout();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      p={4}
    >
      <LockOutlinedIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        401 - Unauthorized
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        maxWidth="400px"
      >
        You do not have permission to access <b>Gateway Admin</b>. Please check your
        credentials or contact an administrator.
      </Typography>
      <Button variant="contained" color="error" sx={{ mt: 4 }} onClick={() => logout()}>
        Sign out
      </Button>
    </Box>
  );
};
